import { combineReducers } from "@reduxjs/toolkit";
import { projectReducer } from "./project/projectReducer";
import { ProjectState } from "./project/projectState";
import { taskReducer } from "./task/taskReducer";
import { TaskState } from "./task/taskState";
import { timerReducer } from "./timer/timerReducer";
import { TimerState } from "./timer/timerState";
import { userReducer } from "./user/userReducer";
import { UserState } from "./user/userState";

export interface KronosState {
  projectState: ProjectState;
  taskState: TaskState;
  timerState: TimerState;
  userState: UserState;
}

export const kronosReducer = combineReducers({
  projectState: projectReducer,
  taskState: taskReducer,
  timerState: timerReducer,
  userState: userReducer,
});
